angular.module('app')
  .config(['$translateProvider', function($translateProvider) {
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.useUrlLoader('/api/frontend/locale/translations.json');
    $translateProvider.preferredLanguage(I18n.locale);
  }]);